/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import React from 'react';
import { isNil } from 'ramda';
import NxTooltip from '../NxTooltip/NxTooltip';
import NxFontAwesomeIcon from '../NxFontAwesomeIcon/NxFontAwesomeIcon';
import { faSquare } from '@fortawesome/free-solid-svg-icons';
import { vulnerabilitySeverityScoreRangeMap, getVulnerabilitySeverityRating } from '../../util/vulnerabilitySeverityRatings';
import { propTypes } from './types';
import './NxVulnerabilityIndicator.scss';
import classnames from 'classnames';
var capitalize = function (string) { return string.charAt(0).toUpperCase() + string.slice(1); };
var NxVulnerabilityIndicator = function NxVulnerabilityIndicator(props) {
    var title = props.title, severityRating = props.severityRating, score = props.score, classNameProp = props.className, presentational = props.presentational, severity = severityRating ? severityRating :
        !isNil(score) ? getVulnerabilitySeverityRating(score) || 'none' :
            'none', className = classnames(classNameProp, "nx-vulnerability-indicator nx-vulnerability-indicator--".concat(severity, " nx-icon--colorful")), label = "vulnerability rating ".concat(severity);
    var icon = (React.createElement(NxFontAwesomeIcon, { "aria-label": presentational ? undefined : label, className: className, icon: faSquare, role: presentational ? 'presentation' : 'graphics-symbol img', fixedWidth: true }));
    var tooltipTitle = title || "Vulnerability: ".concat(capitalize(severity), " (").concat(vulnerabilitySeverityScoreRangeMap[severity], ")");
    return presentational ? icon : (React.createElement(NxTooltip, { title: tooltipTitle }, icon));
};
NxVulnerabilityIndicator.propTypes = propTypes;
export default NxVulnerabilityIndicator;
//# sourceMappingURL=NxVulnerabilityIndicator.js.map